export default __webpack_public_path__ + "static/current-gen-mobile-089d90a9280b59eff9177c1739e8ea27.png";